import React from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import "./footer.scss";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();
    return (
        <div className="footer_container">
            <div className="footer_main">
                <img className="footer-image" src={Image_Url.TVSFOOTER} />
                <span className="footer_text">{t('footer.footertext')}</span>

            </div>

        </div>
    );
}

export default Footer;
